import React from "react";
import {Navbar,Nav} from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import "../styles/navbar.css";

const HeaderComponent: React.FC = () => {

    return (
        <>
            <Navbar collapseOnSelect expand="lg" className="navbar-container">
                <Navbar.Brand href="/" style={styles.navbarLinkTitle}>ALGO VISUALISER</Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse style={styles.navbarLinkTitle} id="responsive-navbar-nav">
                    <Nav className="mr-auto">
                        <Nav.Link href="/sorting" style={styles.navbarLinkTitle}>Sorting</Nav.Link>
                        <Nav.Link href="/path-finding" style={styles.navbarLinkTitle}>Path-Finding</Nav.Link>
                    </Nav>
                    {/* <Nav>
                        <Nav.Link href="#deets" style={styles.navbarLinkTitle}>More deets</Nav.Link>
                        <Nav.Link eventKey={2} href="#memes" style={styles.navbarLinkTitle}>
                            Dank memes
                        </Nav.Link>
                    </Nav> */}
                </Navbar.Collapse>
            </Navbar>
        </>
    )
}

export default HeaderComponent;

const styles = {
    navbarLinkTitle : {
      color: "#fff"
    }
  }